export * from './app-footer.component';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-footer/index.ts